'use client'

import {AlertTriangle, X} from 'lucide-react'

type ConfirmDialogProps = {
    open: boolean
    title: string
    description?: string
    confirmLabel?: string
    cancelLabel?: string
    danger?: boolean
    onConfirm: () => void
    onCancel: () => void
}

export function ConfirmDialog({
                                  open,
                                  title,
                                  description,
                                  confirmLabel = '确定',
                                  cancelLabel = '取消',
                                  danger = false,
                                  onConfirm,
                                  onCancel,
                              }: ConfirmDialogProps) {
    if (!open) return null

    return (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/40">
            <div className="bg-white rounded-card shadow-xl border border-hair w-full max-w-[400px] mx-4">
                {/* Header */}
                <div className="flex items-start justify-between px-6 pt-6 pb-2">
                    <div className="flex items-start gap-3">
                        {danger && (
                            <div className="w-10 h-10 rounded-full bg-red-50 flex items-center justify-center shrink-0 mt-0.5">
                                <AlertTriangle size={20} className="text-red-500"/>
                            </div>
                        )}
                        <div>
                            <h3 className="text-base font-medium text-ink">{title}</h3>
                            {description && (
                                <p className="text-sm text-muted mt-2 whitespace-pre-line leading-relaxed">{description}</p>
                            )}
                        </div>
                    </div>
                    <button
                        onClick={onCancel}
                        className="text-muted hover:text-ink p-1 -mr-1 rounded hover:bg-gray-100 transition-colors shrink-0"
                    >
                        <X size={18}/>
                    </button>
                </div>

                {/* Actions */}
                <div className="flex items-center justify-end gap-3 px-6 py-4">
                    <button
                        onClick={onCancel}
                        className="btn-secondary text-sm"
                    >
                        {cancelLabel}
                    </button>
                    <button
                        onClick={onConfirm}
                        className={`text-sm px-4 py-2 rounded-md font-medium shadow-sm transition-colors ${
                            danger
                                ? 'bg-red-500 hover:bg-red-600 text-white'
                                : 'btn-primary'
                        }`}
                    >
                        {confirmLabel}
                    </button>
                </div>
            </div>
        </div>
    )
}
